<template>
	<div class="image-uploader d-flex flex-column">
		<nk-image v-model="localData.imageSrc" class="mb-2" :options="settings.image" />
		<input class="d-none" type="file" accept="image/*" @change="onFileChange()" id="imageUploadcontrol" ref="imageInput" />
		<div class="buttons d-flex flex-row justify-content-between">
			<nk-button :tabindex="100" :options="settings.selectBtn" @click="selectClicked()" class="ml-1"></nk-button>
			<nk-button :tabindex="101" :options="settings.deleteBtn" @click="deleteClicked()"></nk-button>
		</div>
		<div class="mt-2" v-if="localData.imageName && settings.showFileName">{{ localData.imageName }}</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import _ from 'lodash'

	export default {
		props: {
			options: { type: Object },
			modelValue: { type: String }
		},
		mounted() {
			_.merge(this.settings, this.options)
		},
		data() {
			return {
				localData: {
					originalImage: null,
					imageSrc: '',
					imageName: null,
				},
				settings: {
					width: 150,
					height: 150,
					maximumFileSize: 300000, // in bytes					
					showFileName: false,
					selectBtn: {
						title: this.$t('select'),
						isPrimary: true,
					},
					deleteBtn: {
						title: this.$t('delete'),
						isPrimary: false,
					},
					image: {
						width: 150,
						height: 150,
						defaultImage: 'person'
					}
				}
			}
		},
		watch: {
			modelValue: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					this.localData.imageSrc = val ? val : ''
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.settings = _.extend({}, this.settings, val)
				}
			}
		},
		methods: {
			onFileChange() {
				let image = this.$refs.imageInput.files[0]
				if (!image) return
				if (image.type !== 'image/jpeg' && image.type !== 'image/png') {
					return this.$toast(this.$t('upload.m.format-is-no-supported'), {
						type: 'error',
						duration: 4000
					})
				}
				if (image.size >= this.settings.maximumFileSize) { // Check if the file size is under, 300kb the image size value is in bytes
					return this.$toast(this.$t('upload.m.maximum-filesize-exceeded', { size: this.settings.maximumFileSize / 1000 }), {
						type: 'error',
						duration: 4000
					})
				}
				this.localData.originalImage = image
				this.localData.imageName = image.name
				this.toBase64(image).then((res) => {
					this.localData.imageSrc = res
				})

			},
			hasFile() {
				return this.$refs.imageInput.files.length > 0
			},
			deleteClicked() {
				this.localData.imageSrc = ''
				this.localData.imageName = ''
			},
			selectClicked() {
				this.$refs.imageInput.click()
			},
			getUploadImageData() {
				return this.localData.originalImage
			},
			getUploadImageDataBase64() {
				let base64 = ""
				if (this.localData.originalImage && this.localData.imageSrc.startsWith('data:')) {
					let replace = this.localData.imageSrc.substring(0, this.localData.imageSrc.indexOf(',') + 1)
					base64 = this.localData.imageSrc.replace(replace, '')
				}
				return base64
			},
			toBase64(file) {
				return new Promise((resolve, reject) => {
					const reader = new FileReader()
					reader.readAsDataURL(file)
					reader.onload = () => resolve(reader.result)
					reader.onerror = (error) => reject(error)
				})
			},
		}
	}
</script>

<style>
	.image-uploader {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.image-uploader img {
		background: #fff;
		border-radius: 50%;
	}
</style>